import { useTranslation } from "react-i18next";

function researchSpaceUrl(iri: string, pattern: string | undefined): string | null {
  if (!pattern?.includes("{iri}")) return null;
  try {
    const url = new URL(pattern.replaceAll("{iri}", encodeURIComponent(iri)));
    return url.protocol === "http:" || url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
}

export default function ResearchSpaceLink({ iri }: { iri: string }) {
  const { t } = useTranslation();
  const configured: unknown = import.meta.env["VITE_DMW_RESEARCHSPACE_URL_PATTERN"];
  const pattern = typeof configured === "string" ? configured : undefined;
  const url = researchSpaceUrl(iri, pattern);
  return url === null ? null : (
    <a href={url} target="_blank" rel="noopener noreferrer" className="app-link text-sm">
      {t("data.openResearchSpace")}
    </a>
  );
}
